import React from 'react';
import Timer from 'react-compound-timer'
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button'
import { useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">
              {`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

function TimerCount(props) {
   const [MillS, setMillS] = React.useState(100)
   const [Difference_In_Time,setDifference_In_Time] = React.useState(58540)
   //let Difference_In_Time = 58540;
   const Validate = useSelector(state => state.auth.Validate)
    React.useEffect(()=>{
        
        const interval = setInterval(() => {
        //    let date1 = new Date();
        //    let date2 = new Date(Validate);
        setDifference_In_Time(Difference_In_Time - 600)
            console.log(Difference_In_Time,"Difference_In_Time")
             if(parseInt(Difference_In_Time)>=0){
            setMillS(
               ((Difference_In_Time/1000)*100)/60
            )
            }else{
                setMillS(-1)
                props.setDisabledInp(true)
            }
          }, 1500);
          return () => clearInterval(interval);        
    })
    React.useEffect(()=>{
      if(props.resetTimer === true){
        setMillS(100)
        props.setresetTimer(false)
      }
    },[props.resetTimer])
    return (
        <div>
            {
                 (MillS)<0?
                 <Button
                 size="small"
                 onClick={props.resendAvlidation} 
                 variant="contained" color="primary">
                     <IntlMessages id="Resend" />
                 </Button>
                 :
                 <CircularProgressWithLabel value={MillS} />
            }
          {/*  <Timer
            initialTime={props.Difference_In_Time}
            direction="backward"
            >
                <Timer.Milliseconds />
            </Timer>   
            */}
        </div>
    );
}

export default TimerCount;